// Single source of truth for the localStorage key that records whether the
// user has logged in here before. Read both from React (via the helpers in
// this file) and from the inline boot script that ships in the prerendered
// HTML (see root.tsx — bumping this key requires updating the script too).
const CACHE_USER_ID_KEY = "fatbees:cache-user-id";

export function getCacheUserId(): string {
  // localStorage is unavailable during RR's build-time prerender (Node).
  if (typeof localStorage === "undefined") {
    return "";
  }
  return localStorage.getItem(CACHE_USER_ID_KEY) ?? "";
}

export function setCacheUserId(userId: string): void {
  localStorage.setItem(CACHE_USER_ID_KEY, userId);
}

// Removes the cached id so the next visit is treated as a brand-new one
// — relevant when the user explicitly logs out, so they hit the
// prerendered /login page directly on their next arrival without
// flashing the spinner.
export function clearCacheUserId(): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  localStorage.removeItem(CACHE_USER_ID_KEY);
}
